import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

export default class DisabledOnMobile extends React.Component {
  static propTypes = {
    size: PropTypes.number,
    fill: PropTypes.string,
    color: PropTypes.string,
  };

  static defaultProps = {
    size: 16,
    fill: '#777777',
    color: undefined,
  };

  render() {
    const { size, fill, color, ...restProps } = this.props;

    return (
      <SvgIcon style={{ fill: fill || color }} {...restProps}>
        {
          {
            16: (
              <g>
                <path
                  d="M17,2H7C4.2,2,2,4.2,2,7v7c0,2.8,2.2,5,5,5h8.7l4.8,2.9C20.6,22,20.8,22,21,22c0.2,0,0.3,0,0.5-0.1
		c0.3-0.2,0.5-0.5,0.5-0.9v-7v-1V7C22,4.2,19.8,2,17,2z M20,19.2l-3.5-2.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0H7c-1.7,0-3-1.3-3-3V7
		c0-1.7,1.3-3,3-3h10c1.7,0,3,1.3,3,3v6v1V19.2z"
                />
                <path d="M7.5,9C6.7,9,6,9.7,6,10.5S6.7,12,7.5,12S9,11.3,9,10.5S8.3,9,7.5,9z" />
                <path d="M12,9c-0.8,0-1.5,0.7-1.5,1.5S11.2,12,12,12s1.5-0.7,1.5-1.5S12.8,9,12,9z" />
                <path d="M16.5,9C15.7,9,15,9.7,15,10.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S17.3,9,16.5,9z" />
              </g>
            ),
          }[size]
        }
      </SvgIcon>
    );
  }
}
